import React, { useEffect, useState } from "react";
import sdk from "../../sdk/sdk";
import { useDispatch } from "react-redux";
import {
  CHANGE_LANG,
  LOAD_TRANSLATIONS_SUCCESS,
  LOAD_DATA_TRANSLATIONS_SUCCESS,
  IS_FETCHING,
} from "./actions";
import useTranslations from "../Translations/useTranslations";
import { useCart } from "../Carts/useCart";

function TranslationsLoader({ lang, userId }) {
  const dispatch = useDispatch();
  const [isLangLoaded, setIsLangLoaded] = useState(false);
  const trl = useTranslations();
  const [carts, cartsMethods] = useCart(userId);

  // Load translations
  useEffect(() => {
    if (!lang) return;

    dispatch({ type: CHANGE_LANG, payload: lang });
    dispatch({ type: IS_FETCHING, payload: true });

    Promise.all([
      sdk.me.translations.get({ lang }),
      sdk.me.dataTranslations.get({ lang }),
    ]).then(([translations, dataTranslations]) => {
      dispatch({
        type: LOAD_TRANSLATIONS_SUCCESS,
        payload: translations.payload,
      });
      dispatch({
        type: LOAD_DATA_TRANSLATIONS_SUCCESS,
        payload: dataTranslations.payload,
      });
      dispatch({ type: IS_FETCHING, payload: false });
      setIsLangLoaded(true);
    });
  }, [lang]);

  useEffect(() => {
    if (!isLangLoaded) return;
    if (!userId) return;

    const allCarts = carts?.carts || [];
    if (allCarts.length === 0) return;

    const updateCart = (cart) => {
      const packs = cart.packs || [];
      const products = cart.products || {};

      cart.packs = packs.map((pack) => {
        const codegen = products[pack?.name]?.[0]?.article?.CODGEN;

        if (codegen) {
          pack.name = trl.data.message("GEN", "CODGEN", codegen, "LIBGEN");
        }

        return pack;
      });

      const newProducts = {};
      Object.keys(products).forEach((key) => {
        const codegen = products[key]?.[0]?.article?.CODGEN;

        const newKey = codegen
          ? trl.data.message("GEN", "CODGEN", codegen, "LIBGEN")
          : key;

        newProducts[newKey] = products[key];
      });

      cart.products = newProducts;

      return cart;
    };

    const updatedAll = allCarts.map(updateCart);
    const updatedCurrent = carts.current_cart
      ? updateCart(carts.current_cart)
      : {};

    cartsMethods.syncCartDataByLanguage(userId, updatedAll, updatedCurrent);

    setIsLangLoaded(false);
  }, [isLangLoaded, lang, userId]);

  return <React.Fragment></React.Fragment>;
}

export default TranslationsLoader;
